import * as types from './actionTypes';

export const loginBegin = () => {
  return {
    type: types.LOGIN_BEGIN,
  };
};

export const loginSuccess = (data) => {
  return {
    type: types.LOGIN_SUCCESS,
    data,
  };
};

export const getUserRole = (data) => {
  return {
    type: types.GET_USER_ROLE,
    data,
  };
};
export const setUserRole = (data) => {
  return {
    type: types.SET_USER_ROLE,
    data,
  };
};

export const loginErr = (err) => {
  return {
    type: types.LOGIN_ERR,
    err,
  };
};

export const logoutBegin = () => {
  return {
    type: types.LOGOUT_BEGIN,
  };
};

export const logoutSuccess = (data) => {
  return {
    type: types.LOGOUT_SUCCESS,
    data,
  };
};

export const logoutErr = (err) => {
  return {
    type: types.LOGOUT_ERR,
    err,
  };
};

export const startLogin = (payload, callback) => {
  return {
    type: types.START_LOGIN,
    payload: {
      data: payload,
      callback,
    },
  };
};

export const startLogOut = () => {
  return {
    type: types.START_LOGOUT,
  };
};

export const register = (payload) => {
  return {
    type: types.REGISTER_USER,
    payload,
  };
};
export const registerSuccess = (payload) => {
  return {
    type: types.REGISTER_SUCCESS,
    payload,
  };
};
export const registerError = (payload) => {
  return {
    type: types.REGISTER_ERROR,
    payload,
  };
};

export const setUser = (payload) => {
  return {
    type: types.SET_USER,
    payload,
  };
};

export const updateUserOnboardingCurrentStep = (step) => ({
  type: types.UPDATE_USER_ONBOARDING_CURRENT_STEP,
  payload: step,
});

export const resetRegisterUser = () => {
  return {
    type: types.RESET_REGISTER_USER,
  };
};

export const getDashboardKpi = (payload) => {
  return {
    type: types.GET_KPI,
    payload,
  };
};
export const setKpi = (payload) => {
  return {
    type: types.SET_KPI,
    payload,
  };
};

export const forgotPassword = (payload) => {
  return {
    type: types?.FORGOT_PASSWORD,
    payload,
  };
};

export const forgotPasswordSuccess = (payload) => {
  return {
    type: types.FORGOT_PASSWORD_SUCESS,
    payload,
  };
};

export const forgotPasswordError = (payload) => {
  return {
    type: types.FORGOT_PASSWORD_ERROR,
    payload,
  };
};

export const resetPassword = (payload) => {
  return {
    type: types.RESET_PASSWORD,
    payload,
  };
};

export const resetPasswordSuccess = (payload) => {
  return {
    type: types.RESET_PASSWORD_SUCCESS,
    payload,
  };
};

export const resetPasswordError = (payload) => {
  return {
    type: types.RESET_PASSWORD_ERROR,
    payload,
  };
};

export const resetPasswordReset = () => {
  return {
    type: types.RESET_PASSWORD_RESET,
  };
};

export const emailVerified = (data) => {
  return {
    type: types.EMAIL_VERIFIED,
    data,
  };
};

export const resendOTP = (data) => {
  return {
    type: types.RESEND_OTP,
    data,
  };
};

export const verifyEmailStatus = (data) => {
  return {
    type: types.VERIFY_EMAIL_STATUS,
    data,
  };
};

export const otpVerified = (data) => {
  return {
    type: types.OTP_VERIFIED,
    data,
  };
};

export const changePassword = (data) => {
  return {
    type: types.CHANGE_PASSWORD,
    data,
  };
};

export const changePasswordSuccess = (data) => {
  return {
    type: types.CHANGE_PASSWORD_SUCESS,
    data,
  };
};

export const changePasswordError = (data) => {
  return {
    type: types.CHANGE_PASSWORD_ERROR,
    data,
  };
};
export const resetAllData = () => {
  return {
    type: types.RESET_ALL_DATA,
  };
};
export const selectLanguage = (data) => {
  return {
    type: types.SELECT_LANGUAGE,
    data,
  };
};
export const setLanguage = (data) => {
  return {
    type: types.SET_LANGUAGE,
    data,
  };
};

// old data

export const employeeRegister = (payload) => {
  return {
    type: types.EMPLOYEE_REGISTER,
    payload,
  };
};

export const setMetaParams = (data) => {
  return {
    type: types.SET_META_PARAMS,
    payload: data,
  };
};

export const registerRedirection = (data) => {
  return {
    type: types.REGISTER_REDIRECTION,
    payload: data,
  };
};

export const verifyOtp = (payload) => {
  return {
    type: types.VERIFY_OTP,
    payload,
  };
};

export const otpRedirection = (data) => {
  return {
    type: types.OTP_REDIRECTION,
    payload: data,
  };
};
export const isMpinCreated = (data) => {
  return {
    type: types.ISMPINCREATED_REDIRECTION,
    payload: data,
  };
};

export const createMpin = (payload) => {
  return {
    type: types.CREATE_MPIN,
    payload,
  };
};

export const createMpinRedirection = (data) => {
  return {
    type: types.CREATE_MPIN_REDIRECTION,
    payload: data,
  };
};

export const employeeLogin = (payload, callback) => {
  return {
    type: types.EMPLOYEE_LOGIN,
    payload: {
      data: payload,
      callback,
    },
  };
};

export const employeeLoginRedirection = (data) => {
  return {
    type: types.EMPLOYEE_LOGIN_REDIRECTION,
    payload: data,
  };
};

export const getExportPortfolio = () => {
  return {
    type: types.GET_EXPORT_PORTFOLIO,
  };
};

export const setActiveUrl = (data) => {
  return {
    type: types.SET_ACTIVE_URL,
    payload: data,
  };
};
export const getBusinessCategories = (lang) => {
  return {
    type: types.GET_BUSINESS_CATEGORIES,
    data: lang ?? 'en',
  };
};
export const setBusiessCategories = (data) => {
  return {
    type: types.SET_BUSINESS_CATEGORIES,
    payload: data,
  };
};
export const setPaymentStatus = (data) => {
  return {
    type: types.SET_PAYMENT_STATUS,
    payload: data,
  };
};
export const setPaymentTypes = (data) => {
  return {
    type: types.SET_PAYMENT_TYPES,
    payload: data,
  };
};

export const almaOnboardingDetails = (data) => {
  return {
    type: types.ALMA_ONBOARDING_DETAILS,
    payload: data,
  };
};
export const updatePaymentMethod = (data) => {
  return {
    type: types.UPDATE_PAYMENT_METHOD,
    payload: data,
  };
};
export const setAlmaOnboardingDetails = (data) => {
  return {
    type: types.SET_ALMA_ONBOARDING_DETAILS,
    payload: data,
  };
};
export const setAlmaOnboardingStatus = (data) => {
  return {
    type: types.SET_ALMA_ONBOARDING_STATUS,
    payload: data,
  };
};
export const setMe = (payload) => {
  return {
    type: types.SET_ME,
    payload,
  };
};
/** @param {{ accessToken?: string }} [payload] — pass accessToken to use that Bearer for /me (e.g. immediately after reset). */
export const getMe = (payload) => {
  return {
    type: types.GET_ME,
    payload: payload || {},
  };
};
export const getMeFailure = () => {
  return {
    type: types.GET_ME_FAILURE,
  };
};
